import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Model
import { Receipt } from '../models/receipt.model';
import { RequestModel } from '../models/request.model';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  initEvents: Subject<number> = new Subject<number>();

  hidden: boolean = true;
  success: boolean = false;
  operation: 'SHOW' | 'EDIT' | 'CREATE';
  receipt: Receipt;
  request: RequestModel;

  constructor() { }

  public hide() {
    this.hidden = true;
    this.success = false;
    this.receipt = null;
    this.request = null;
  }

  public show(operation: 'SHOW' | 'EDIT' | 'CREATE', receipt?: Receipt, request?: RequestModel) {
    this.operation = operation;

    if (receipt) 
      this.receipt = receipt;
    
    if (request) 
      this.request = request;
    
    this.activateTooltip();
    this.initEvents.next(receipt.number);
    
    this.hidden = false;
  }
  
  public getOperation() {
    return this.operation;
  }
  
  private activateTooltip() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })  
  } 
}
